function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

async function checkAndUpdateCartDiscount(sections = null) {
  if (!window.theme?.shouldCheckDiscount) {
    return null;
  }
  
  try {
    // Section Rendering API ile cart discount data'sını al
    const sectionResponse = await fetch(window.Shopify.routes.root + '?section_id=api-cart-discount-data');
    
    if (!sectionResponse.ok) {
      console.warn('Section rendering failed:', sectionResponse.status);
      return null;
    }
    
    const sectionHtml = await sectionResponse.text();
    
    // JSON içeriğini parse et
    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionHtml, 'text/html');
    const scriptTag = doc.querySelector('script[data-cart-discount-data]');
    
    if (!scriptTag) {
      console.warn('Cart discount data script not found');
      return null;
    }
    
    const discountData = JSON.parse(scriptTag.textContent);
    const cart_total_price_wo_calisan_indirim = discountData.calculated_value;
    
    // Cart attribute'unu güncelle
    const requestBody = {
      attributes: {
        '_ct_hd': cart_total_price_wo_calisan_indirim,
        'Channel': 'Online Store',
      }
    };
    
    // Eğer sections parametresi verilmişse, isteğe ekle
    if (sections && sections.length > 0) {
      requestBody.sections = sections;
      requestBody.sections_url = window.location.pathname;
    }
    
    const updateResponse = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(requestBody)
    });
    
    if (!updateResponse.ok) {
      console.warn('Cart attribute update failed:', updateResponse.status);
      return null;
    }
    
    // Eğer sections gönderildiyse, response'dan sections'ları döndür
    if (sections && sections.length > 0) {
      const result = await updateResponse.json();
      return result.sections || null;
    }
    
    return null;
  } catch (error) {
    console.error('Cart discount check error:', error);
    return null;
  }
}

window.addEventListener('hollyWishlistAppAddToCart', async () => {
  await checkAndUpdateCartDiscount();
});

window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract?.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add?.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract?.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add?.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
// class ArrowSubMenu {

//   constructor(self) {
//     this.submenu = self.parentNode.querySelector('.sub-menu');
//     this.arrow = self;
//     // Add functionality to buttons
//     self.addEventListener('click', (e) => this.toggle_submenu(e));
//   }

//   toggle_submenu(e) {
//     e.preventDefault();
//     let submenu = this.submenu;

//     if (!submenu.classList.contains('active')) {
//       submenu.classList.add('active');

//     } else {
//       submenu.classList.remove('active');
//       this.arrow.blur();
//     }
//   }
// }
// let arrows = document.querySelectorAll('.thb-arrow');
// arrows.forEach((arrow) => {
//   new ArrowSubMenu(arrow);
// });

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      // Check if this is a recommendation product card loaded via AJAX or recently viewed product card section
      const isRecommendationCard = this.closest('product-recommendations') || this.closest('recently-viewed-products');
      const isRecommendationLoaded = isRecommendationCard && (
        this.closest('product-recommendations')?.classList.contains('product-recommendations--loaded') ||
        this.closest('recently-viewed-products')?.classList.contains('product-recommendations--loaded')
      );

      // Only initialize if it's NOT a recommendation card, OR if it's a recommendation card that has been loaded via AJAX
      if (!isRecommendationCard || isRecommendationLoaded) {
        this.initializeProductCard();
      }
    }

    initializeProductCard() {
      // Prevent double initialization
      if (this.hasAttribute('data-initialized')) {
        return;
      }
      this.setAttribute('data-initialized', 'true');

      this.swatches = this.querySelector('.product-card-swatches');
      this.slider = this.querySelector('.product-card--image');
      this.sizeSlider = this.querySelector('.product-card-sizes--slider');
      this.image = this.querySelector('.product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
      // Iki adimli hizli sepete ekleme paneli (product-card-quick-add.liquid)
      this.quick_add_root = this.querySelector('[data-quick-add]');


      this.slideWidth = this.image ? this.image.offsetWidth : 0;
      this.slidesToScroll = 1;
      this.reachedEnd = 0;

      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.additional_images.length > 0) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }
      if (this.quick_add_root) {
        this.enableQuickAddPanel();
      }
      this.enableMobileSwipe();

      // Cart discount text animation
      this.enableCartDiscountAnimation();
    }
    enableCartDiscountAnimation() {
      const carousel = this.querySelector('.hp-cart-discount-carousel');
      if (!carousel) return;
      
      const textsCount = parseInt(carousel.dataset.textsCount);
      if (!textsCount || textsCount <= 1) return;

      const texts = carousel.querySelectorAll('.hp-cart-discount-text');
      let currentIndex = 0;

      function showNextText() {
        // Hide current text
        texts[currentIndex].style.transform = 'translateY(-100%)';

        // Show next text
        currentIndex = (currentIndex + 1) % textsCount;
        texts[currentIndex].style.transform = 'translateY(0%)';

        // Hide other texts
        texts.forEach(function (text, index) {
          if (index !== currentIndex) {
            if (index < currentIndex) {
              text.style.transform = 'translateY(-100%)';
            } else {
              text.style.transform = 'translateY(100%)';
            }
          }
        });
      }

      // Initialize first text position
      texts.forEach((text, index) => {
        if (index === 0) {
          text.style.transform = 'translateY(0%)';
        } else {
          text.style.transform = 'translateY(100%)';
        }
      });

      // Start rotation every 5 seconds
      setInterval(showNextText, 5000);
    }
    enableAdditionalImages() {
      this.viewport = this.querySelector('.product-card--image-inner');
      this.imageWrapper = this.querySelector('.product-card--image-wrapper');
      
      this.enableMouseHoverNavigation();
      
      this.additional_images.forEach((image) => {
        window.addEventListener('load', () => {
          lazySizes.loader.unveil(image);
        });
      });
    }
    
    enableMouseHoverNavigation() {
      if (!this.imageWrapper || !this.slider) {
        return;
      }
      
      this.allImages = Array.from(this.slider.querySelectorAll('figure.aspect-ratio'));
      
      
      if (this.allImages.length <= 1) {
        return;
      }
      
      this.currentImageIndex = 0;
      this.totalImages = this.allImages.length;
      
      
      this.allImages.forEach((img, index) => {
        if (index === 0) {
          img.style.display = 'block';
        } else {
          img.style.display = 'none';
        }
      });
      
      this.imageWrapper.addEventListener('mousemove', (e) => {
        const rect = this.imageWrapper.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const imageWidth = rect.width;
        
        const imageIndex = Math.floor((x / imageWidth) * this.totalImages);
        const clampedIndex = Math.max(0, Math.min(imageIndex, this.totalImages - 1));
        
        
        if (clampedIndex !== this.currentImageIndex) {
          this.currentImageIndex = clampedIndex;
          this.showImage(clampedIndex);
        }
      });
      
      this.imageWrapper.addEventListener('mouseleave', () => {
        this.currentImageIndex = 0;
        this.showImage(0);
      });
    }
    
    showImage(index) {
      if (!this.allImages || index < 0 || index >= this.allImages.length) {
        return;
      }

      this.allImages.forEach((img, i) => {
        img.style.display = 'none';
      });

      this.allImages[index].style.display = 'block';
    }

    /* ------------------------------------------------------------------
     * Mobilde gorseller arasinda sag/sol kaydirma (en fazla ilk 4 gorsel).
     *
     * Masaustundeki hover gezintisi (enableMouseHoverNavigation) aynen
     * kaliyor; burasi yalnizca 767px ve alti ekranlarda calisiyor. Kart yatay
     * kayan bir listedeyse (carousel) parmak hareketi listeye birakiliyor.
     * Gorunum product-grid.css'te (.is-swipeable).
     * ------------------------------------------------------------------ */
    enableMobileSwipe() {
      const mobile = window.matchMedia('(max-width: 767px)');
      if (!mobile.matches) {
        // Telefon yatayda acilip dikeye cevrilirse sonradan devreye girsin
        const onChange = (evt) => {
          if (!evt.matches) return;
          mobile.removeEventListener('change', onChange);
          this.enableMobileSwipe();
        };
        mobile.addEventListener('change', onChange);
        return;
      }

      const wrapper = this.querySelector('.product-card--image-wrapper');
      const track = this.querySelector('.product-card--image-inner');
      if (!wrapper || !track || wrapper.classList.contains('is-swipeable')) return;

      const slides = Array.from(track.querySelectorAll(':scope > figure.aspect-ratio')).slice(0, 4);
      if (slides.length < 2 || this.isInHorizontalScroller()) return;

      let index = 0;
      let startX = 0;
      let startY = 0;
      let startTime = 0;
      let deltaX = 0;
      let direction = null; // null: henuz belli degil, 'x', 'y' ya da 'ignore'
      let suppressClickUntil = 0;

      const dots = document.createElement('div');
      dots.className = 'product-card--swipe-dots';
      dots.setAttribute('aria-hidden', 'true');
      dots.innerHTML = slides.map(() => '<span></span>').join('');
      wrapper.appendChild(dots);
      const dotItems = Array.from(dots.children);

      const render = (offset = 0) => {
        track.style.setProperty('--swipe-x', `calc(${index * -100}% + ${offset}px)`);
        dotItems.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      };

      // Kirpilan gorseller tembel yukleniyor: kart ekrana gelince 2. gorsel,
      // ilk dokunusta hepsi yukleniyor ki kaydirirken bos kare gorunmesin.
      const loadSlides = (count) => {
        slides.slice(0, count).forEach((slide) => {
          slide.querySelectorAll('img').forEach((img) => {
            if (img.loading === 'lazy') img.loading = 'eager';
            if (img.classList.contains('lazyload') && window.lazySizes) {
              window.lazySizes.loader.unveil(img);
            }
          });
        });
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            loadSlides(2);
          },
          { rootMargin: '200px 0px' }
        );
        observer.observe(wrapper);
      }

      wrapper.addEventListener(
        'touchstart',
        (evt) => {
          direction = null;
          if (
            !mobile.matches ||
            evt.touches.length > 1 ||
            evt.target.closest('button, input, select, [data-quick-add], .product-card--quickview')
          ) {
            direction = 'ignore';
            return;
          }
          loadSlides(slides.length);
          startX = evt.touches[0].clientX;
          startY = evt.touches[0].clientY;
          startTime = Date.now();
          deltaX = 0;
        },
        { passive: true }
      );

      wrapper.addEventListener(
        'touchmove',
        (evt) => {
          if (direction === 'ignore' || direction === 'y') return;

          const dx = evt.touches[0].clientX - startX;
          const dy = evt.touches[0].clientY - startY;

          if (!direction) {
            if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
            direction = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
            if (direction === 'y') return;
            wrapper.classList.add('is-swiping');
          }

          // Yatay harekette sayfa kaymasin
          if (evt.cancelable) evt.preventDefault();

          // Ilk / son gorselde lastik etkisi
          const atEdge = (index === 0 && dx > 0) || (index === slides.length - 1 && dx < 0);
          deltaX = atEdge ? dx / 3 : dx;
          render(deltaX);
        },
        { passive: false }
      );

      const onEnd = () => {
        if (direction !== 'x') return;
        direction = null;
        wrapper.classList.remove('is-swiping');

        const isFlick = Math.abs(deltaX) > 20 && Date.now() - startTime < 250;
        const threshold = isFlick ? 20 : Math.min(60, wrapper.offsetWidth * 0.2);
        if (deltaX <= -threshold && index < slides.length - 1) index += 1;
        else if (deltaX >= threshold && index > 0) index -= 1;

        render(0);
        suppressClickUntil = Date.now() + 400;
      };
      wrapper.addEventListener('touchend', onEnd);
      wrapper.addEventListener('touchcancel', onEnd);

      // Kaydirmanin sonunda gelen tiklama urun sayfasina gitmesin
      wrapper.addEventListener(
        'click',
        (evt) => {
          if (Date.now() < suppressClickUntil) {
            evt.preventDefault();
            evt.stopPropagation();
          }
        },
        true
      );

      wrapper.classList.add('is-swipeable');
      render(0);
    }

    isInHorizontalScroller() {
      for (let node = this.parentElement; node && node !== document.body; node = node.parentElement) {
        if (node.matches('.carousel, theme-scroll, .swiper, .flickity-enabled, .splide')) return true;
        // overflow-y: auto olan dikey kutularda overflow-x de "auto" hesaplaniyor;
        // gercekten yatay tasma var mi diye ayrica bakiliyor.
        const overflowX = getComputedStyle(node).overflowX;
        if ((overflowX === 'auto' || overflowX === 'scroll') && node.scrollWidth > node.clientWidth + 1) return true;
      }
      return false;
    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll('.product-card-swatch');
      this.color_index = this.swatches.dataset.index;
      this.org_srcset = this.image ? this.image.dataset.srcset : '';

      this.addEventListener('change', this.onSwatchChange.bind(this));

      swatch_list.forEach((swatch) => {
        window.addEventListener('load', () => {
          if (swatch.dataset.srcset) {
            let image = new Image();
            image.srcset = swatch.dataset.srcset;
            lazySizes.loader.unveil(image);
          }
        });
        swatch.addEventListener('click', this.onSwatchClick);
        swatch.addEventListener('mouseover', this.onSwatchHover.bind(this, swatch));
      });
    }
    onSwatchClick() {
      window.location.href = this.dataset.href;
    }
    onSwatchHover(swatch) {
      let swatch_input = swatch.previousElementSibling;
      swatch_input.checked = true;
      this.current_options[this.color_index] = swatch.querySelector('span').innerText;
      this.updateMasterId();
      swatch_input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    onSwatchChange(evt) {
      if (this.image) {
        if (evt.target.dataset.srcset) {
          this.image.setAttribute('srcset', evt.target.dataset.srcset);
        } else {
          this.image.setAttribute('srcset', this.org_srcset);
        }
      }
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size');

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;
          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then(async (response) => {
              if (response.status) {
                return;
              }
              
              const sections = this.getSectionsToRender().map((section) => section.section);
              const updatedSections = await checkAndUpdateCartDiscount(sections);
              
              if (updatedSections) {
                response.sections = updatedSections;
              }
              
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });

      // Size slider setup
      this.sizeNavPrev = this.querySelector('.product-card-sizes--nav-prev');
      this.sizeNavNext = this.querySelector('.product-card-sizes--nav-next');
      
      if (this.sizeSlider && size_list.length > 0) {
        this.itemsPerView = 5;
        this.sizeSlideWidth = 24; // product-grid.css => .product-card-sizes--size 
        this.sizeReachedEnd = false;
        
        const totalItems = size_list.length;
        if (false && totalItems > this.itemsPerView) { // Kaydırma Kapatıldı
          const remainingItems = totalItems - this.itemsPerView;
          this.currentIndex = Math.floor(remainingItems / 2);
        } else {
          this.currentIndex = 0;
        }
        this.sizeResizeObserver = new ResizeObserver((entries) => {
          this.sizeReachedEnd = this.currentIndex + this.itemsPerView >= size_list.length;
          this.onSizeNavDisabled();
          this.checkSizeSliderVisibility();
        });
        this.sizeResizeObserver.observe(size_list[0]);
        
        this.debouncedOnSizeScroll = debounce((event) => {
          this.onSizeScroll(event);
        }, 100);

        this.sizeNavPrev.addEventListener('click', this.onSizeNavClick.bind(this, 'prev'));
        this.sizeNavNext.addEventListener('click', this.onSizeNavClick.bind(this, 'next'));
        this.sizeSlider.addEventListener('scroll', this.debouncedOnSizeScroll.bind(this));
        this.sizeSlider.addEventListener('resize', this.debouncedOnSizeScroll.bind(this));
        
        // Başlangıç pozisyonuna scroll et
        if (this.currentIndex > 0) {
          setTimeout(() => {
            this.sizeSlider.scrollLeft = this.currentIndex * this.sizeSlideWidth;
          }, 1);
        }
        
        // Initial nav state
        this.onSizeNavDisabled();
        
        // Tüm itemler görünüyorsa navigation'ı gizle ve ortalama yap
        this.checkSizeSliderVisibility();
      }
    }
    onSizeScroll() {
      // Mevcut scroll pozisyonuna göre index'i hesapla (30px sabit genişlik)
      this.currentIndex = Math.round(this.sizeSlider.scrollLeft / this.sizeSlideWidth);
      const size_list = this.size_options.querySelectorAll('.product-card-sizes--size');
      this.sizeReachedEnd = this.currentIndex + this.itemsPerView >= size_list.length;
      this.onSizeNavDisabled();
    }
    onSizeNavClick(direction, e) {
      const size_list = this.size_options.querySelectorAll('.product-card-sizes--size');
      const totalItems = size_list.length;
      
      if (direction === 'next') {
        // Sonraki 4 item'a git, eğer sonda değilse
        if (this.currentIndex + this.itemsPerView < totalItems) {
          this.currentIndex = Math.min(this.currentIndex + this.itemsPerView, totalItems - this.itemsPerView);
        }
      } else if (direction === 'prev') {
        // Önceki 4 item'a git
        this.currentIndex = Math.max(this.currentIndex - this.itemsPerView, 0);
      }
      
      // Scroll pozisyonunu hesapla (30px * currentIndex)
      this.sizeScrollPos = this.currentIndex * this.sizeSlideWidth;

      this.sizeSlider.scrollTo({
        left: this.sizeScrollPos,
        behavior: "smooth"
      });
    }
    onSizeNavDisabled() {
      const size_list = this.size_options.querySelectorAll('.product-card-sizes--size');
      const totalItems = size_list.length;
      
      if (this.sizeNavPrev) {
        this.sizeNavPrev.disabled = this.currentIndex === 0 ? 1 : 0;
      }
      if (this.sizeNavNext) {
        this.sizeNavNext.disabled = this.currentIndex + this.itemsPerView >= totalItems ? 1 : 0;
      }
    }
    checkSizeSliderVisibility() {
      if (!this.sizeSlider || !this.size_options) return;
      
      const size_list = this.size_options.querySelectorAll('.product-card-sizes--size');
      const totalItems = size_list.length;
      const container = this.querySelector('.product-card-sizes--container');
      
      // Eğer 4 veya daha az item varsa (tüm itemler görünüyor)
      if (totalItems <= this.itemsPerView) {
        // Navigation butonlarını gizle
        if (this.sizeNavPrev) this.sizeNavPrev.style.display = 'none';
        if (this.sizeNavNext) this.sizeNavNext.style.display = 'none';
        
        // Container'ı ortala
        if (container) {
          container.style.justifyContent = 'center';
        }
      } else {
        // Navigation butonlarını göster
        if (this.sizeNavPrev) this.sizeNavPrev.style.display = '';
        if (this.sizeNavNext) this.sizeNavNext.style.display = '';
        
        // Container'ı başa hizala
        if (container) {
          container.style.justifyContent = 'start';
        }
      }
    }

    /* ------------------------------------------------------------------
     * Iki adimli hizli sepete ekleme (product-card-quick-add.liquid)
     *
     * 1) "Sepete ekle" -> panel acilir
     * 2) Beden (+ varsa Boy) secilir -> siyah "Sepete ekle" sepete ekler
     *
     * "Boy" ayri bir Shopify secenegi degil: pantolonlarda beden degeri
     * "30/32" (bel/boy) formatinda. Urun sayfasindaki pants-size-select ile
     * ayni mantik burada da uygulaniyor.
     * ------------------------------------------------------------------ */
    enableQuickAddPanel() {
      const root = this.quick_add_root;

      this.qaTrigger = root.querySelector('[data-quick-add-trigger]');
      this.qaPanel = root.querySelector('[data-quick-add-panel]');
      this.qaSizeButtons = Array.from(root.querySelectorAll('[data-quick-add-sizes] .product-card--quick-add-option'));
      this.qaLengthButtons = Array.from(root.querySelectorAll('[data-quick-add-lengths] .product-card--quick-add-option'));
      this.qaSubmit = root.querySelector('[data-quick-add-submit]');
      this.qaError = root.querySelector('[data-quick-add-error]');

      if (!this.qaTrigger || !this.qaPanel || !this.qaSubmit) return;

      this.qaIsPants = root.dataset.isPants === 'true';
      this.qaSizeIndex = parseInt(root.dataset.index, 10) || 0;
      this.qaBaseOptions = (root.dataset.options || '').split(',');
      this.qaSelectedSize = '';
      this.qaSelectedLength = '';

      this.qaTrigger.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        this.openQuickAddPanel();
      });

      this.qaSizeButtons.forEach((button) => {
        button.addEventListener('click', (evt) => {
          evt.preventDefault();
          evt.stopPropagation();
          if (button.classList.contains('is-disabled')) return;
          this.onQuickAddSizeSelect(button);
        });
      });

      this.qaLengthButtons.forEach((button) => {
        button.addEventListener('click', (evt) => {
          evt.preventDefault();
          evt.stopPropagation();
          if (button.classList.contains('is-disabled')) return;
          this.qaSelectedLength = button.dataset.value;
          this.qaLengthButtons.forEach((b) => b.classList.toggle('is-selected', b === button));
          this.setQuickAddError('');
        });
      });

      this.qaSubmit.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        this.quickAddPanelSubmit();
      });

      // Panel icine tiklamak karti tetiklemesin
      this.qaPanel.addEventListener('click', (evt) => evt.stopPropagation());

      // Karttan cikinca / baska bir yere tiklayinca kapan
      this.addEventListener('mouseleave', () => this.closeQuickAddPanel());
      this.qaOnDocumentClick = (evt) => {
        if (!root.contains(evt.target)) this.closeQuickAddPanel();
      };
      this.qaOnKeydown = (evt) => {
        if (evt.key === 'Escape') this.closeQuickAddPanel();
      };
      document.addEventListener('click', this.qaOnDocumentClick);
      document.addEventListener('keydown', this.qaOnKeydown);

      // Mobil: gorselin sag altindaki sepet ikonu ayni paneli aciyor,
      // panelin kapatma (x) butonu yalnizca mobilde gorunuyor.
      this.qaIcon = root.querySelector('[data-quick-add-icon]');
      this.qaClose = root.querySelector('[data-quick-add-close]');
      this.qaIcon?.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        this.openQuickAddPanel();
      });
      this.qaClose?.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        this.closeQuickAddPanel();
      });

      // Mobil: panel acikken kartin baska bir yerine dokunmak urun sayfasina
      // gitmesin, yalnizca paneli kapatsin.
      this.addEventListener(
        'click',
        (evt) => {
          if (!root.classList.contains('is-open') || root.contains(evt.target)) return;
          if (!window.matchMedia('(max-width: 767px)').matches) return;
          evt.preventDefault();
          evt.stopPropagation();
          this.closeQuickAddPanel();
        },
        true
      );
    }

    openQuickAddPanel() {
      // Sayfada ayni anda tek panel acik kalsin
      document.querySelectorAll('product-card [data-quick-add].is-open').forEach((el) => {
        if (el !== this.quick_add_root) {
          el.classList.remove('is-open');
          el.querySelector('[data-quick-add-trigger]')?.setAttribute('aria-expanded', 'false');
          el.querySelector('[data-quick-add-icon]')?.setAttribute('aria-expanded', 'false');
        }
      });

      this.quick_add_root.classList.add('is-open');
      this.qaTrigger.setAttribute('aria-expanded', 'true');
      this.qaIcon?.setAttribute('aria-expanded', 'true');
      this.refreshQuickAddAvailability();
    }

    closeQuickAddPanel() {
      if (!this.quick_add_root?.classList.contains('is-open')) return;
      this.quick_add_root.classList.remove('is-open');
      this.qaTrigger?.setAttribute('aria-expanded', 'false');
      this.qaIcon?.setAttribute('aria-expanded', 'false');
      this.setQuickAddError('');
    }

    onQuickAddSizeSelect(button) {
      this.qaSelectedSize = button.dataset.value;
      this.qaSizeButtons.forEach((b) => b.classList.toggle('is-selected', b === button));
      this.setQuickAddError('');

      if (!this.qaIsPants) return;

      // Bel degisince o bele ait boylar yeniden hesaplanir; secili boy artik
      // gecerli degilse secim temizlenir.
      this.refreshQuickAddLengths();
      const stillValid = this.qaLengthButtons.some(
        (b) => b.dataset.value === this.qaSelectedLength && !b.classList.contains('is-disabled')
      );
      if (!stillValid) {
        this.qaSelectedLength = '';
        this.qaLengthButtons.forEach((b) => b.classList.remove('is-selected'));
      }
    }

    getQuickAddVariants() {
      if (!this.qaVariantData) {
        const holder = this.quick_add_root.querySelector('[type="application/json"]');
        try {
          this.qaVariantData = JSON.parse(holder.textContent);
        } catch (e) {
          console.error('quick-add: varyant verisi okunamadi', e);
          this.qaVariantData = [];
        }
      }
      return this.qaVariantData;
    }

    // Beden disindaki secenekler (or. Renk) karttaki secili degerle eslesiyor mu
    quickAddOtherOptionsMatch(variant) {
      return variant.options.every((value, index) => {
        if (index === this.qaSizeIndex) return true;
        return String(this.qaBaseOptions[index] || '').toLowerCase() === String(value || '').toLowerCase();
      });
    }

    findQuickAddVariant(sizeValue) {
      const target = String(sizeValue || '').toLowerCase();
      return this.getQuickAddVariants().find((variant) => {
        if (String(variant.options[this.qaSizeIndex] || '').toLowerCase() !== target) return false;
        return this.quickAddOtherOptionsMatch(variant);
      });
    }

    refreshQuickAddAvailability() {
      this.qaSizeButtons.forEach((button) => {
        const value = button.dataset.value;
        let available;

        if (this.qaIsPants) {
          // Bel: o bele ait HERHANGI bir boy stokta ise secilebilir
          const prefix = `${value}/`.toLowerCase();
          available = this.getQuickAddVariants().some(
            (variant) =>
              String(variant.options[this.qaSizeIndex] || '')
                .toLowerCase()
                .startsWith(prefix) &&
              variant.available &&
              this.quickAddOtherOptionsMatch(variant)
          );
        } else {
          const variant = this.findQuickAddVariant(value);
          available = Boolean(variant && variant.available);
        }

        button.classList.toggle('is-disabled', !available);
        button.disabled = !available;
      });

      if (this.qaIsPants) this.refreshQuickAddLengths();
    }

    refreshQuickAddLengths() {
      const waist = this.qaSelectedSize;

      this.qaLengthButtons.forEach((button) => {
        const value = button.dataset.value;
        let available;

        if (waist) {
          // Bel secildiyse yalnizca o bele ait kombinasyon
          const variant = this.findQuickAddVariant(`${waist}/${value}`);
          available = Boolean(variant && variant.available);
        } else {
          // Henuz bel secilmedi: bu boyun herhangi bir belde stogu var mi
          const suffix = `/${value}`.toLowerCase();
          available = this.getQuickAddVariants().some(
            (variant) =>
              String(variant.options[this.qaSizeIndex] || '')
                .toLowerCase()
                .endsWith(suffix) &&
              variant.available &&
              this.quickAddOtherOptionsMatch(variant)
          );
        }

        button.classList.toggle('is-disabled', !available);
        button.disabled = !available;
      });
    }

    setQuickAddError(message) {
      if (!this.qaError) return;
      this.qaError.textContent = message || '';
      this.qaError.hidden = !message;
    }

    quickAddPanelSubmit() {
      const strings = (window.theme && window.theme.variantStrings) || {};

      if (!this.qaSelectedSize) {
        this.setQuickAddError(
          this.qaIsPants ? strings.selectSizeLength || '' : strings.selectSize || ''
        );
        return;
      }
      if (this.qaIsPants && !this.qaSelectedLength) {
        this.setQuickAddError(strings.selectSizeLength || '');
        return;
      }

      const sizeValue = this.qaIsPants ? `${this.qaSelectedSize}/${this.qaSelectedLength}` : this.qaSelectedSize;
      const variant = this.findQuickAddVariant(sizeValue);

      if (!variant || !variant.available) {
        this.setQuickAddError(strings.soldOut || strings.unavailable || '');
        return;
      }

      this.setQuickAddError('');
      this.qaSubmit.classList.add('loading');
      this.qaSubmit.setAttribute('aria-disabled', 'true');

      const formData = new FormData();
      formData.append('id', variant.id);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      fetch(`${theme.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        },
        body: formData
      })
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            this.setQuickAddError(response.description || response.message || '');
            return;
          }

          const sections = this.getSectionsToRender().map((section) => section.section);
          const updatedSections = await checkAndUpdateCartDiscount(sections);
          if (updatedSections) {
            response.sections = updatedSections;
          }

          this.renderContents(response);
          this.closeQuickAddPanel();

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.qaSubmit.classList.remove('loading');
          this.qaSubmit.removeAttribute('aria-disabled');
        });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index].toLowerCase() === option.toLowerCase();
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((button) => {
                const sizeValue = button.querySelector('span')?.textContent?.trim();
                const optionEntry = fieldset_options.find((option) => option.value === sizeValue);
                if (optionEntry) {
                  button.classList.toggle('is-disabled', optionEntry.isUnavailable);
                } else {
                  button.classList.remove('is-disabled');
                }
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            return;
          }
          
          const sections = this.getSectionsToRender().map((section) => section.section);
          const updatedSections = await checkAndUpdateCartDiscount(sections);
          
          if (updatedSections) {
            response.sections = updatedSections;
          }
          
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }

        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      document.getElementById('Cart-Drawer')?.open();
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}


/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    constructor() {
      super();

    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      // Add functionality to buttons
      this.addEventListener('click', (e) => {
        this.close_panel(e);
      });
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
      if (!this.cc.dataset.init) {
        this.cc.addEventListener('click', (e) => {
          let panel = document.querySelectorAll('.side-panel.active');
          if (panel) {
            this.close_panel(e, panel[0]);
          }
        });
        this.cc.dataset.init = true;
      }
    }
    close_panel(e, panel) {
      if (!panel) {
        panel = this.closest('.side-panel');

        if (!panel) {
          return;
        }
      }
      panel.classList.remove('active');
      panel.setAttribute('inert', '');

      if (document.body.classList.contains('open-cc--product')) {
        document.body.classList.remove('open-cc--product');
        setTimeout(() => {
          document.querySelector('#Product-Drawer-Content').innerHTML = '';
        }, 260);
      } else if (panel?.classList.contains('cart-drawer') && document.querySelector('.view-products-panel.active')) {
        return;
      } else {
        document.body.classList.remove('open-cc');
        document.body.classList.remove('overflow-hidden');
      }

    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {

      this.isOpen = false;
      let button = document.getElementById('cart-drawer-toggle');


      // Add functionality to buttons
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      // Holly Wishlist Remove From Cart
      window.addEventListener('hollyWishListAppRemoveFromCart', async () => {
        await checkAndUpdateCartDiscount();
        this.refresh();
      });

      window.addEventListener('hp-cart-sync:cart-updated', () => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.notesToggle();
      this.removeProductEvent();
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    open() {
      document.body.classList.add('open-cc');
      this.classList.add('active');
      this.removeAttribute('inert');
      this.focus();
      this.isOpen = true;
      dispatchCustomEvent('cart-drawer:open');
    }
    close() {
      document.body.classList.remove('open-cc');
      this.classList.remove('active');
      this.setAttribute('inert', '');
      this.isOpen = false;
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');

          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    notesToggle() {
      let notes_toggle = document.getElementById('order-note-toggle');

      if (!notes_toggle) {
        return;
      }

      notes_toggle.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.add('active');
      });
      notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': document.getElementById('mini-cart__notes').value
        })
      });
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then(async (state) => {
          const parsedState = JSON.parse(state);

          const sections = this.getSectionsToRender().map((section) => section.section);
          const updatedSections = await checkAndUpdateCartDiscount(sections);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (updatedSections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(updatedSections[section.section], section.selector);
            } else if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          this.notesToggle();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        });
    }
    refresh() {
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
          this.notesToggle();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function ResizeSelect
 */
if (!customElements.get('resize-select')) {
  class ResizeSelect extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.select = this.querySelector('select');
      this.resizeSelect();
      this.addEventListeners();
    }
    addEventListeners() {
      this.addEventListener('change', this.resizeSelect.bind(this));
      window.addEventListener('load', this.resizeSelect.bind(this));
      window.addEventListener('resize-select', this.resizeSelect.bind(this));
    }
    resizeSelect() {
      let tempOption = document.createElement('option');
      tempOption.textContent = this.select.selectedOptions[0].textContent;

      let tempSelect = document.createElement('select'),
        offset = 10;
      tempSelect.style.visibility = 'hidden';
      tempSelect.style.position = 'fixed';
      tempSelect.appendChild(tempOption);
      this.after(tempSelect);
      if (tempSelect.clientWidth > 0) {
        this.select.style.width = `${+tempSelect.clientWidth + offset}px`;
      }
      tempSelect.remove();
    }
  }
  customElements.define('resize-select', ResizeSelect);
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;
      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));
    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc--product');
      this.drawer.classList.remove('active');
      this.drawer.setAttribute('inert', '');

      setTimeout(() => {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
      }, 260);

    }
    setupEventListener(e) {
      if (e.target.classList.contains('thb-hotspot-content') || e.target.classList.contains('combine-product-link')) return;
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        // Hide add to cart button if data-hide-add-to-cart attribute is set
        if (this.dataset?.hideAddToCart === 'true') {
          this.drawer.classList.add('hide-add-to-cart');
        } else {
          this.drawer.classList.remove('hide-add-to-cart');
        }

        this.body.classList.add('open-cc--product');
        this.drawer.classList.add('active');
        this.drawer.removeAttribute('inert');

        this.drawer.focus();

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}


/**
 *  @class
 *  @function ThemeScroll
 */
if (!customElements.get('theme-scroll')) {
  class ThemeScroll extends HTMLElement {
    constructor() {
      super();

      this.viewport = this.querySelector('.theme-scroll--inner');
      this.slideWidth = 274;
      this.slidesToScroll = 1;
    }
    connectedCallback() {
      window.OverlayScrollbarsGlobal.OverlayScrollbars({
        target: this,
        elements: {
          viewport: this.viewport,
        },
        overflow: {
          y: 'hidden'
        }
      }, {});

      this.init();
    }
    init() {
      this.setSlides();
      this.reachedEnd = 0;

      if (this.slides.length < 1) {
        return;
      }
      this.nav = this.querySelector('.theme-scroll-nav');
      this.navPrev = this.querySelector('.flickity-prev');
      this.navNext = this.querySelector('.flickity-next');
      this.resizeObserver = new ResizeObserver((entries) => {
        this.slideWidth = this.slides[1]?.offsetLeft - this.slides[0]?.offsetLeft;
        this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == this.viewport.scrollLeft;
        this.onNavDisabled();
      }, {
        root: this
      });
      this.debouncedOnScroll = debounce((event) => {
        this.onScroll(event);
      }, 100);
      this.insertBefore(this.nav, this.querySelector('.os-scrollbar-vertical'));
      this.setListeners();
    }
    setSlides() {
      this.slides = this.querySelectorAll('.carousel__slide');
    }
    setListeners() {
      this.nav.addEventListener('click', this.onNavClick.bind(this));
      this.viewport.addEventListener('scroll', this.debouncedOnScroll.bind(this));
      this.viewport.addEventListener('resize', this.debouncedOnScroll.bind(this));
      this.resizeObserver.observe(this.slides[0]);
    }
    onScroll() {
      this.reachedEnd = (this.viewport.scrollWidth - this.viewport.offsetWidth) - Math.floor(this.viewport.scrollLeft) <= 1;
      this.onNavDisabled();
    }
    onNavClick(e) {
      if (!e.target.matches('.flickity-nav')) {
        return;
      }
      if (e.target.name === 'next') {
        this.scrollPos = this.viewport.scrollLeft + this.slidesToScroll * this.slideWidth;
      } else if (e.target.name === 'prev') {
        this.scrollPos = this.viewport.scrollLeft - this.slidesToScroll * this.slideWidth;
      }
      this.viewport.scrollTo({
        left: this.scrollPos,
        behavior: "smooth"
      });
    }
    onNavDisabled() {
      if (this.navPrev) {
        this.navPrev.disabled = this.viewport.scrollLeft === 0 ? 1 : 0;
      }
      if (this.navNext) {
        this.navNext.disabled = this.reachedEnd ? 1 : 0;
      }
    }
  }
  customElements.define('theme-scroll', ThemeScroll);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
      this.collapsed_mobile = this.classList.contains('accordion--collapsed-mobile');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (this.initialized) { return; }
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));

      this.initialized = true;
      if (this.collapsed_mobile) {
        window.addEventListener('resize', () => {
          this.details.open = window.innerWidth > 768;
        });
        window.dispatchEvent(new Event('resize'));
      }
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';

      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';

      this.dispatchEvent(new Event('animationend', { bubbles: false }));
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

/**
 *  Animations
 */
window.theme_animation_instances = createThemeAnimations();

function createThemeAnimations() {
  if (!document.body.classList.contains('animations-true')) {
    return false;
  }
  return ScrollTrigger.batch('.products .product-card--image-primary, .collection-card--link, .blog-post .featured-image--link, .image-with-text .image-with-text--image, .gallery .gallery-item--image, .multiple-media-with-text .multiple-media-with-text--image, .layered-images-with-text .layered-images-media', {
    start: "top 90%",
    onEnter: (elements) => {
      gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
    }
  });
}
document.addEventListener('theme:reload_animations', () => {
  window.theme_animation_instances = createThemeAnimations();
});

document.addEventListener('DOMContentLoaded', () => {
  let scrollbarWidth = window.innerWidth - document.body.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
});

/**
 *  @class
 *  @function ShopTheLookHotspot
 */
if (!customElements.get('shop-the-look-hotspot')) {
  class ShopTheLookHotspot extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.hotspot = this.querySelector('.thb-hotspot');
      this.bubble = this.querySelector('.thb-hotspot-bubble');
      
      if (!this.hotspot || !this.bubble) return;

      this.calculateOptimalPosition();
      
      this.resizeHandler = this.calculateOptimalPosition.bind(this);
      window.addEventListener('resize', this.resizeHandler);
    }

    disconnectedCallback() {
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
      }
    }

    calculateOptimalPosition() {
      const container = this.closest('.shop-the-look');
      if (!container) return;

      const containerRect = container.getBoundingClientRect();
      const hotspotRect = this.hotspot.getBoundingClientRect();
      
      if(containerRect.width < 250) return;
      
      let bubbleWidth = this.bubble.offsetWidth || 200;
      
      const hotspotRelativeLeft = hotspotRect.left - containerRect.left;
      const hotspotCenter = hotspotRelativeLeft + (hotspotRect.width / 2);
      
      const bubbleLeft = hotspotCenter - (bubbleWidth / 2);
      const bubbleRight = bubbleLeft + bubbleWidth;
      
      const margin = 15;
      let adjustedLeft = hotspotCenter; // Varsayılan: hotspot'ın ortası
      let needsAdjustment = false;
      
      if (bubbleLeft < margin) {
        adjustedLeft = margin + (bubbleWidth / 3);
        needsAdjustment = true;
      }
      else if (bubbleRight > (containerRect.width - margin)) {
        // Sağdan taşıyor: bubble'ı hotspot'un solunda aç
        // Bubble'ın sağ kenarı hotspot'un soluna gelsin
        adjustedLeft = -(bubbleWidth/3);
        needsAdjustment = true;
      }
      
      if (needsAdjustment) {
        this.bubble.style.setProperty('--bubble-left', `${adjustedLeft}px`);
        this.bubble.style.setProperty('--bubble-margin-left', `${-bubbleWidth / 2}px`);
      } else {
        this.bubble.style.removeProperty('--bubble-left');
        this.bubble.style.removeProperty('--bubble-margin-left');
      }
    }
  }
  customElements.define('shop-the-look-hotspot', ShopTheLookHotspot);
}